function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

import { instrumentMethod } from '../tools/instrumentMethod';
import { Observable } from '../tools/observable';
import { elapsed, clocksNow, timeStampNow } from '../tools/utils/timeUtils';
import { normalizeUrl } from '../tools/utils/urlPolyfill';
import { shallowClone } from '../tools/utils/objectUtils';
import { addEventListener } from './addEventListener';
var xhrObservable;
var xhrContexts = new WeakMap();
export function initXhrObservable(configuration) {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable(configuration);
  }

  return xhrObservable;
}

function createXhrObservable(configuration) {
  return new Observable(function (observable) {
    var _instrumentMethod = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr),
        stopInstrumentingStart = _instrumentMethod.stop;

    var _instrumentMethod2 = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
      sendXhr(call, configuration, observable);
    }, {
      computeHandlingStack: true
    }),
        stopInstrumentingSend = _instrumentMethod2.stop;

    var _instrumentMethod3 = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr),
        stopInstrumentingAbort = _instrumentMethod3.stop;

    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
}

function openXhr(_ref) {
  var xhr = _ref.target,
      _ref$parameters = _slicedToArray(_ref.parameters, 2),
      method = _ref$parameters[0],
      url = _ref$parameters[1];

  xhrContexts.set(xhr, {
    state: 'open',
    method: String(method).toUpperCase(),
    url: normalizeUrl(String(url))
  });
}

function sendXhr(_ref2, configuration, observable) {
  var xhr = _ref2.target,
      _ref2$parameters = _slicedToArray(_ref2.parameters, 1),
      body = _ref2$parameters[0],
      handlingStack = _ref2.handlingStack;

  var context = xhrContexts.get(xhr);

  if (!context) {
    return;
  }

  var startContext = context;
  startContext.state = 'start';
  startContext.startClocks = clocksNow();
  startContext.isAborted = false;
  startContext.xhr = xhr;
  startContext.handlingStack = handlingStack;
  startContext.requestBody = body;
  var hasBeenReported = false;

  var _instrumentMethod4 = instrumentMethod(xhr, 'onreadystatechange', function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      // Try to report the XHR as soon as possible, because the XHR may be mutated by the
      // application during a future event. For example, Angular is calling .abort() on
      // completed requests during an onreadystatechange event, so the status becomes '0'
      // before the request is collected.
      onEnd();
    }
  }),
      stopInstrumentingOnReadyStateChange = _instrumentMethod4.stop;

  var onEnd = function onEnd() {
    unsubscribeLoadEndListener();
    stopInstrumentingOnReadyStateChange();

    if (hasBeenReported) {
      return;
    }

    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
    completeContext.status = xhr.status;

    if (typeof xhr.response === 'string') {
      completeContext.responseBody = xhr.response;
    }

    observable.notify(shallowClone(completeContext));
  };

  var _addEventListener = addEventListener(configuration, xhr, 'loadend', onEnd),
      unsubscribeLoadEndListener = _addEventListener.stop;

  observable.notify(startContext);
}

function abortXhr(_ref3) {
  var xhr = _ref3.target;
  var context = xhrContexts.get(xhr);

  if (context) {
    context.isAborted = true;
  }
}